// extracted by mini-css-extract-plugin
export var copyableField = "_np-4";
export var customerBadge = "_np-0";
export var customerInfoTitle = "_np-2";
export var details = "_np-1";
export var dropdownContainer = "_np-5";
export var dropdownImage = "_np-6";
export var editAssigneeForm = "_np-a";
export var editButton = "_np-3";
export var email = "_np-7";
export var hidden = "_np-d";
export var input = "_np-8";
export var saveButton = "_np-b";
export var shopifyIcon = "_np-c";
export var suggestionBadge = "_np-e";
export var suggestionText = "_np-f";
export var username = "_np-9";